import { useState, useEffect } from "react"
import { BuilderComponent } from "@builder.io/react"
import { builder } from "@lib/register-custom-components"

const LaunchModalBuilderSection = ({ optionId }: { optionId: string }) => {
  const [builderContentJson, setBuilderContentJson] = useState(undefined)

  useEffect(() => {
    builder
      .get("configurator-input-launch-modal", {
        key: optionId,
        query: { data: { optionId: { $eq: optionId } } },
      })
      .promise()
      .then((data) => {
        setBuilderContentJson(data)
      })
  }, [optionId])

  if (builderContentJson) {
    return (
      <BuilderComponent
        model="configurator-input-launch-modal"
        content={builderContentJson}
        key={optionId}
      />
    )
  } else {
    return <></>
  }
}

export default LaunchModalBuilderSection
